import { http, tokenStore } from "./client";

export async function login(email, password) {
  const { data } = await http.post("/api/v1/auth/login/", { email, password });
  const payload = data.data;
  tokenStore.set(payload.access, payload.refresh);
  return payload.user;
}

export async function logout() {
  const refresh = tokenStore.refresh;
  try {
    if (refresh) await http.post("/api/v1/auth/logout/", { refresh });
  } catch {
    /* best-effort; clear locally regardless */
  } finally {
    tokenStore.clear();
  }
}

export async function me() {
  // No tokens at all → not logged in; skip the pointless 401 round-trip.
  if (!tokenStore.access && !tokenStore.refresh) return null;
  try {
    const { data } = await http.get("/api/v1/auth/profile/");
    return data.data;
  } catch (err) {
    const status = err?.response?.status;
    if (status === 401 || status === 403) return null;
    throw err;
  }
}

/** Change the logged-in user's password (current password required). */
export async function changePassword(currentPassword, newPassword, confirmPassword) {
  const { data } = await http.post("/api/v1/auth/change-password/", {
    current_password: currentPassword,
    new_password: newPassword,
    confirm_password: confirmPassword,
  });
  return data.data;
}

/** Request a reset link be emailed. Resolves the same way whether or not the
 *  address exists — the server never reveals which emails are registered. */
export async function requestPasswordReset(email) {
  const { data } = await http.post("/api/v1/auth/password-reset/", { email });
  return data.data;
}

/** Set a new password using a token from the emailed reset link. */
export async function confirmPasswordReset(token, newPassword, confirmPassword) {
  const { data } = await http.post("/api/v1/auth/password-reset/confirm/", {
    token,
    new_password: newPassword,
    confirm_password: confirmPassword,
  });
  return data.data;
}
